window.upsell_html = {};

async function postRequest(url, data) {
    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(data)
    });

    return await response.json();
}

$(document).on("click","cart-note-dialog .close_cart_note_button", function (){
  document.querySelector("#cart-drawer").click();
});

$(document).on("click", ".add_up_product_btn", function () { 
  const handle = $(this).data("product-handle");

  $("#upsellProductPopup").addClass("upsell_item_details");
  $("#upsellProductPopup").html(upsell_html[handle]);
  document.querySelector("x-modal.upsell-modal").setAttribute("open", "");
  initThumbSwiper();
  updateSoldOutSizes();
  setMedia_popup();
  autoActivateOptions();
});




async function fetch_upsell_cart_item()
{
    const cart  = await getShopifyCart();
    const items = {products: []};
    cart.items.forEach(item => {
        items.products.push({
            "product_title" : item.product_title,
            "product_type"  : item.product_type,
            "product_id" : item.product_id,
            "variant_title" : item.title
        });
    });

    if (items.products.length === 0) {
      return ;
    }

    items['lang'] = Shopify.locale;

    const apiUrl = "http://app.lawni.com/api/upsell/product";
    // const apiUrl = "http://127.0.0.1:8000/api/upsell/product";
    const resp = await postRequest(apiUrl, items);

    document.querySelector(".upsell_cart_product_list").innerHTML = resp.html;
    init_swiper();
    get_preload_html();
}


function init_swiper() {
  new Swiper(".upsell_cart_product_list", {
    slidesPerView: 1,
    spaceBetween: 20,
    loop: true,
    watchSlidesProgress: true,
    
    pagination: {
      el: ".upsell_cart_product_list .swiper-pagination",
      clickable: true,
    },
    
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },
  });
}
          
function initThumbSwiper() {
  if( isMobile() == false ){
    var thumbsSwiper = new Swiper(".popup-thumbs-swiper", {
      spaceBetween: 5,
      slidesPerView: 5,
      watchSlidesProgress: true,
    });

    var mainSwiper = new Swiper(".popup-main-swiper", {
      spaceBetween: 3,
      thumbs: {
        swiper: thumbsSwiper,
      },
      pagination: {
        el: ".popup-main-swiper .swiper-pagination",
        clickable: true,
      },
      noSwiping: true,
      noSwipingClass: 'swiper-wrapper',
    });

    const thumbs = document.querySelector(".popup-thumbs.swiper").querySelectorAll(".thumb-img");
    thumbs.forEach(thumb => {
      thumb.addEventListener("click", () => {
        thumbs.forEach(t => t.classList.remove("active"));
        thumb.classList.add("active");
      });
    });
  }


  if( isMobile() ){
    var mainSwiper = new Swiper(".popup-main-swiper", {
      spaceBetween: 3,
      thumbs: {
        swiper: thumbsSwiper,
      },
      pagination: {
        el: ".popup-main-swiper .swiper-pagination",
        clickable: true,
      }
    });
  }
}


function isMobile(){
  if (window.innerWidth < 768) {
    return true;
  }

  return false;
}

$(document).on("click", ".upsell-popup .option-btn", function () {
    $(this).siblings().removeClass("active");
    $(this).addClass("active");

    if ($(this).closest(".popup-option").data("option-name") === "Style") {
        setMedia_popup();
    }
    
    updateSoldOutSizes();
    updateVariantFormID();
    // selectOption();
});

function updateVariantFormID() {
  const elem = document.querySelector("#upsellProductPopup .upsell-popup");
  if (!elem) return;

  const productJson = JSON.parse(elem.getAttribute("data-product-json"));
  const popupWrapper = document.querySelector(".upsell_popup_cart .upsell-popup");
  if (!popupWrapper) return;

  const selectedOptions = {};

  // Loop through each option group (Style, Size, Material)
  popupWrapper.querySelectorAll(".popup-option").forEach((optionGroup, index) => {
    // Try active first
    let selectedBtn = optionGroup.querySelector(".option-btn.active");

    // If no active (sold out case), pick first enabled
    if (!selectedBtn) {
      selectedBtn = optionGroup.querySelector(".option-btn.is-disabled");
    }

    if (selectedBtn) {
      selectedOptions[index] = selectedBtn.dataset.optionValuue;
    }
  });

  // Ensure all options are selected
  if (Object.keys(selectedOptions).length !== productJson.options.length) {
    console.warn("Incomplete option selection", selectedOptions);
    return;
  }

  // Find matching variant
  const matchedVariant = productJson.variants.find(variant =>
    variant.options.every((opt, i) => opt == selectedOptions[i])
  );

  if (!matchedVariant) {
    console.warn("No matching variant found", selectedOptions);
    return;
  }

  // Update hidden input
  $(".upsell-form .variant-input").val(matchedVariant.id);

  const $addBtn = $(".popup-add-btn");

  if (matchedVariant.available) {
    $addBtn
      .prop("disabled", false)
      .removeClass("sold-out");
  } else {
    $addBtn
      .prop("disabled", true)
      .addClass("sold-out");
  }
}





document.addEventListener("submit", async function (e) {
  if (!e.target.closest("form.upsell-form")) return;

  e.preventDefault();

  const form = e.target;

  form.querySelector(".popup-add-btn")?.classList.add("loader_show");

  const variantId = form.querySelector(".variant-input").value;

  const data = {
    id: Number(variantId),
    quantity: 1,
    properties: {
      _upsell: "yes"
    }
  };


  const resp = await postRequest("/cart/add.js", data);

  document.dispatchEvent(new CustomEvent("cart:refresh"));

  setTimeout(() => {
    document.querySelector(".upsell-modal").removeAttribute("open");
  }, 1500);
});


function getOptionByValue(data, optionValue) {
  return data.find(item => item.option_value == optionValue);
}

function upsell_stack_button_manage(){
  // const elems = document.querySelectorAll(".upsell_popup_cart fieldset.optionsize.active");
  const elems = document.querySelectorAll(".upsell_popup_cart fieldset.optionsize.active label.block-swatch.active:not(.is-disabled)");
  if( elems.length == 0 ){
    return ;
  }

  if( elems.length != 2 ){
    document.querySelector(".upsell-popup form.upsell-stack-form").classList.add("disabled");
    return ;
  }

  document.querySelector(".upsell-popup form.upsell-stack-form").classList.remove("disabled");
}

function upsell_stack_inventory_manage() {

  const json = get_stack_json();
  if (!json) return;

  const colors = document.querySelectorAll(".upsell-popup-middle fieldset.optionsize");

  const totalSizes = {};
  const remaining = {};

  colors.forEach(fs => {

    const color = fs.getAttribute("datavall");
    if (!json[color]) return;

    json[color].forEach(item => {
      totalSizes[item.option_value] = item.inventory_quantity;
      remaining[item.option_value] = item.inventory_quantity;
    });

  });

  const activeFieldsets = [...document.querySelectorAll(".upsell-popup-middle fieldset.optionsize.active")]
    .sort((a,b)=>parseInt(a.dataset.index)-parseInt(b.dataset.index));


  activeFieldsets.forEach(fs => {

    const currentSize = fs.querySelector("label.active")?.getAttribute("data-name");

    fs.querySelectorAll("label").forEach(label => {

      const size = label.getAttribute("data-name");

      if (remaining[size] > 0) {
        label.classList.remove("is-disabled");
      } else {
        label.classList.add("is-disabled");
      }

    });

    if (currentSize && remaining[currentSize] > 0) {
      remaining[currentSize] -= 1;
    }
  });
}


document.addEventListener('click', function (e) {
  const swatch = e.target.closest('.block-swatch');

  if (swatch) {
    upsell_stack_button_manage();
    upsell_stack_inventory_manage();
  }
});


function get_stack_json(){
  const elem = document.querySelector("#upsellProductPopup .upsell-popup");
  if( elem ){
    const json = JSON.parse(elem.getAttribute("data-product-json"));
    return json;
  }
}

document.addEventListener("submit", async function (e) {
  if (!e.target.closest("form.upsell-stack-form")) return;

  e.preventDefault();

  const form = e.target;
  form.querySelector(".popup-add-btn")?.classList.add("loader_show");

  const bundleId = 'bundle-' + Date.now();
  const json = get_stack_json();
  
  const elems = document.querySelectorAll(".upsell_popup_cart fieldset.optionsize.active");
  if( elems.length != 2 ){
    return ;
  }

  items = [];

  elems.forEach(elem => {
    const color = elem.getAttribute("datavall");
    const size = elem.getAttribute("data-name");
    const data = getOptionByValue(json[color], size);

    items.push({
      id: data['shopify_id'],
      quantity: 1,
      properties: {
        "_bundle_id": bundleId,
        "_upsell" : "yes"
      }
    });
  });

  const resp = await postRequest("/cart/add.js", {items});

  document.dispatchEvent(new CustomEvent("cart:refresh"));

  setTimeout(() => {
    document.querySelector(".upsell-modal").removeAttribute("open");
  }, 1500);
});


function setMedia_popup(){
   if( isMobile() == false ){
      setMedia_popup_desktop();
    }else{
      setMedia_popup_mobile()
    }
}





function setMedia_popup_desktop() 
{
  slideClickedOnce = false;
  const thinWideValues = ["Thin", "Wide"];

  const elems = document.querySelectorAll(".popup-option .option-btn.active");
  const swiperEl = document.querySelector(".popup-main-swiper");
  const swiper = swiperEl.swiper;

  for (let i = 0; i < elems.length; i++) {
    const value = elems[i].getAttribute("data-option-value");

    if (thinWideValues.includes(value)) {
      const images = document.querySelectorAll(".upsell-popup img.thumb-img");

      images.forEach(image => {
        const slide = image.closest(".swiper-slide");
        if (!slide) return;

        if (image.getAttribute("alt") === `#Style_${value}`) {
          slide.style.display = "block";

          if (!slideClickedOnce) {
            const slideIndex = [...slide.parentNode.children].indexOf(slide);
            swiper.slideTo(slideIndex, 0);
            slideClickedOnce = true;
            document.querySelector(".upsell-popup .thumb-img.active")?.classList.remove("active");
          }
        } else {
          slide.style.display = "none";
        }
      });
    }
  }
}





function setMedia_popup_mobile(retry = 0) {
  const popup = document.querySelector('.upsell-popup');
  if (!popup) return;

  const swiperEl = popup.querySelector('.popup-main-swiper');
  const wrapper = swiperEl?.querySelector('.swiper-wrapper');

  if (!swiperEl || !wrapper || !swiperEl.swiper) {
    if (retry < 10) {
      setTimeout(() => setMedia_popup_mobile(retry + 1), 100);
    }
    return;
  }

  const swiper = swiperEl.swiper;

  const activeStyleBtn = popup.querySelector(
    '.popup-option[data-option-name="Style"] .option-btn.active'
  );
  if (!activeStyleBtn) return;

  const selectedStyle = activeStyleBtn.dataset.optionValue; // Thin | Wide

  /* ---------- CACHE ORIGINAL SLIDES (ONCE) ---------- */
  if (!swiperEl._allSlides) {
    swiperEl._allSlides = Array.from(wrapper.children);
  }

  const allSlides = swiperEl._allSlides;

  /* ---------- REBUILD WRAPPER ---------- */
  wrapper.innerHTML = '';

  const visibleSlides = allSlides.filter(slide => {
    const img = slide.querySelector('img');
    return img && img.alt === `#Style_${selectedStyle}`;
  });

  visibleSlides.forEach(slide => {
    slide.style.display = '';
    slide.classList.remove('swiper-slide-hidden');
    wrapper.appendChild(slide);
  });

  /* ---------- HARD RESET SWIPER ---------- */
  swiper.updateSlides();
  swiper.updateSize();
  swiper.updateProgress();
  swiper.updateSlidesClasses();

  if (swiper.pagination && swiper.pagination.el) {
    swiper.pagination.render();
    swiper.pagination.update();
  }

  swiper.slideTo(0, 0);
}




function updateSoldOutSizes() {
  const variantEls = document.querySelectorAll(".current_popup_variant .popup_variatnt-priceee");

  if (!variantEls.length) return;

  const selectedOptions = {};

  document.querySelectorAll(".popup-option").forEach(optionBlock => {
    const optionName = optionBlock.dataset.optionName;
    const activeBtn = optionBlock.querySelector(".option-btn.active");

    if (activeBtn) {
      selectedOptions[optionName] = activeBtn.dataset.optionValuue;
    }
  });

  document
    .querySelectorAll('[data-option-name="Size"] .option-btn')
    .forEach(btn => btn.classList.remove("is-disabled"));

  variantEls.forEach(variantEl => {
    const qty = Number(variantEl.dataset.qrt);
    if (qty > 0) return;

    var titleParts = variantEl
      .getAttribute("variant-title")
      .split(" / ")
      .map(v => v.trim());

    titleParts = titleParts.map(item => item === 'Gold Plated Silver' ? '18k Gold Plated' : item);

    let match = true;

    Object.entries(selectedOptions).forEach(([key, value]) => {
      if (key == "Size") return;

      if (!titleParts.includes(value)) {
        match = false;
      }
    });

    if (!match) return;

    const sizeValue = titleParts.find(v =>
      document.querySelector(
        `[data-option-name="Size"] .option-btn[data-option-valuue="${v}"]`
      )
    );

    if (!sizeValue) return;

    const sizeBtn = document.querySelector(
      `[data-option-name="Size"] .option-btn[data-option-valuue="${sizeValue}"]`
    );

    if (sizeBtn) {
      sizeBtn.classList.add("is-disabled");
      sizeBtn.classList.remove("active");
    }
  });
}

function selectOption(){
  const elems = document.querySelectorAll(".upsell-popup-middle .popup-option");
  elems.forEach(elem => {
    const is_exists = elem.querySelector(".option-btn.active");
    if (!is_exists) {
      elem.querySelector(".option-btn").click();
      return;
    }
  });
}



function get_preload_html(){
  const handles = Array.from(
    document.querySelectorAll(".upsell_cart_product_list .add_up_product_btn")
  ).map(btn => btn.dataset.productHandle);

  handles.forEach(handle => {
    if( handle == "stacks"){
      section_name = "upsell-stack-product-cart-popup";
    }else{
      section_name = "upsell-product-cart-popup";
    }

    if( Shopify.locale == "en" ){
      var url = `${location.origin}/products/${handle}?section_id=${section_name}`;
    }else{
      var url = `${location.origin}/${Shopify.locale}/products/${handle}?section_id=${section_name}`;
    }

    fetch(url)
      .then(res => res.text())
      .then(html => {
        upsell_html[handle] = html;
      });
  });
}


document.addEventListener("click", function (event) {
    if( ! document.querySelector("x-modal.upsell-modal") ){
      return ;
    }
    const outsideEl = event.target.closest(".upsell-close-outside");

    if (outsideEl) {
      document.querySelector(".upsell-modal").removeAttribute("open");
    }
  });




  setInterval(() => {
    const is_cart_empty = document.querySelectorAll(".drawer--center-body").length;
    if( is_cart_empty ){
      return ;
    }
    
    const length = document.querySelectorAll(".upsell_cart_product_list .product_item").length;

    if( length === 0 ){
      fetch_upsell_cart_item();
    }
  }, 2500);



function autoActivateOptions() {
  const optionGroups = document.querySelectorAll(".popup-option");

  optionGroups.forEach(group => {
    const buttons = group.querySelectorAll(".option-btn");

    // Check: koi active hai ya nahi
    const hasActive = group.querySelector(".option-btn.active");
    // Agar koi active nahi hai
    if (!hasActive) {
      const firstEnabled = group.querySelector(".option-btn:not(.is-disabled)");
      if (firstEnabled) {
        firstEnabled.click();
      }
    }
  });
}


function formatNumber(n) {
  return n >= 1000 ? n.toLocaleString() : n.toString();
}


function updateVariantPrice() {
  const variant_id  = document.querySelector('[data-block-type="buy-buttons"] form [name="id"]')?.value;
  if( ! variant_id ){
    return ;
  }

  const variantElem = document.querySelector(`.current_variant .variatnt-priceee[data-id="${variant_id}"]`);

  if (!variantElem) return;

  const price = Number(variantElem.getAttribute("data-price")) / 100;

  const priceWrapper = document.querySelector(".price-cont sale-price");
  if (!priceWrapper) return;

  // purana price remove karo (agar ho)
  const oldPrice = priceWrapper.querySelector(".buckscc-money");
  if( ! oldPrice ){
    return "failed";
  }
  oldPrice.remove();

  // naya price element banao
  const priceEl = document.createElement("span");
  priceEl.className = "money";
  priceEl.innerText = `${formatNumber(price)} AED`;

  priceWrapper.appendChild(priceEl);
  return "success";
}


const intervalupdateVariantPrice = setInterval(() => {
  const result = updateVariantPrice();

  if (result === "success") {
    clearInterval(intervalupdateVariantPrice);
  }
}, 500);


document.addEventListener("click", function(event) {
  const elem = event.target.closest(".product-card__quick-add-button");

  if (elem) {
    elem.classList.add("spinner-show");

    setTimeout(() => {
      elem.classList.remove("spinner-show");
    }, 1500);
  }
});

document.addEventListener("click", function(event) {
  const elem = event.target.closest("a.product-card__media");

  if (elem) {
    const quickAddBtn = elem.nextElementSibling;
    if (quickAddBtn?.classList.contains("product-card__quick-add-button")) {
      quickAddBtn.classList.add("spinner-show");
    
      setTimeout(() => {
        quickAddBtn.classList.remove("spinner-show");
      }, 500);
    }
  }
});